import axios from "axios";

export const state = {
    studentbursaries: [],
};

export const getters = {
    studentbursaries: state => state.studentbursaries,
};

export const mutations = {
    setStudentBursaries(state, newValue) {
        state.studentbursaries = newValue
    },
};

export const actions = {
    fetchStudentBursaries({ commit }) {
        axios.get('/studentbursaries').then(res => {
            commit('setStudentBursaries', res.data.bursaries);
        })
    },
};
